import { SpecPathValue } from './SpecPathValue';
import _ from 'lodash';

export function FactoidSpecs({ factoid, skipPaths = [], specRegex = null }) {
  if(!factoid) {
    return null;
  }

  let {derivedSpecs, missingInSchema, missingExplanation} = factoid;

  if (!derivedSpecs && !missingInSchema) {
    return <span className={'p-1'}><span className={'badge badge-secondary'}>No specs data</span></span>;
  } else if(_.isArray(derivedSpecs) || _.isArray(missingInSchema)) {
    let specsViz, missingSpecsViz, explanationViz;

    if(derivedSpecs?.length) {
      if(skipPaths?.length) {
        derivedSpecs = _.filter(derivedSpecs, p => !skipPaths.includes(p[0]));
      }

      specsViz = _.map(derivedSpecs, ([path, value]) => <div className={'ml-2'} key={path} >
        <SpecPathValue path={path} value={value} specRegex={specRegex}/>
      </div>);
    }

    if(missingInSchema?.length) {
      if(skipPaths?.length) {
        missingInSchema = _.filter(missingInSchema, p => !skipPaths.includes(p[0]));
      }
      missingSpecsViz = <div className={'bg-light-danger p-1 rounded'}>
        Missing:
        {_.map(missingInSchema, ([path, value]) => <div className={'ml-2'} key={path} >
          <SpecPathValue path={path} value={value} specRegex={specRegex}/>
        </div>)}
      </div>
    }

    if(missingExplanation) {
      explanationViz = <div className={'mt-1 p-2 small border rounded bg-light-secondary text-secondary'}>
        <strong>Explanation</strong>: {missingExplanation}
      </div>
    }

    return <div>
      {specsViz}
      {missingSpecsViz}
      {explanationViz}
    </div>
  } else {
    return <pre className={'ml-2 small break-word-all'} key={factoid._id}>{JSON.stringify({derivedSpecs, missingInSchema}, null, 2)}</pre>;
  }
}
